import { store, storeActions } from '~/utility/BinSentry-ui-utility';

export const NoMenuMixin = superClass => class extends superClass {
  connectedCallback() {
    super.connectedCallback();
    store.dispatch(storeActions.setMenuHidden(true));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    store.dispatch(storeActions.setMenuHidden(false));
  }
};
